<template>
<v-dialog v-model="dialog" width="700">
    <v-card>
      <v-card-title class="text-h5 bg-info d-flex justify-space-between" primary-title>
        <div class="align-center">
          <v-icon size="large" style="color: white" class="pr-3">
            mdi-information
          </v-icon>
          <span style="color: white">
            Ungespeicherte Änderungen
        </span>
        </div>
          <Button class="close-button" large icon @click="closeDialog">
              <v-icon color="white">
                  mdi-close
              </v-icon>
          </Button>
      </v-card-title>
      <v-card-text class="pa-4">
          <v-alert
            :value="true"
            type="info"
            icon="mdi-alert"
            variant="outlined"
          >
            Es liegen ungespeicherte Änderungen vor. Beim Verlassen der Seite gehen diese verloren.
            Um die Änderungen zu speichern, bleiben Sie auf der Seite und klicken Sie auf Änderungen speichern. 
          </v-alert>
      </v-card-text>
      <v-card-actions>
          <v-btn variant="flat" color="orange" @click="leave">
            <v-icon class="pr-2" color="white">
                mdi-directions
            </v-icon>
            <span class="text-white">Seite trotzdem verlassen</span>
          </v-btn>
          <v-spacer></v-spacer>
          <Button variant="flat" color="info" @click="stay">
            <v-icon class="pr-2">
                mdi-stop
            </v-icon>
              Auf der Seite bleiben
          </Button>
      </v-card-actions>
    </v-card>
</v-dialog>
</template>
<script>
import Button from '@s/views/general_components/components/Button'

export default {
    name: "page-leave-dialog",
    data() {
        return {
            dialog: false
        }
    },
    props: {
      nextFunction: {
        type: Function,
        required: true
      }
    },
    watch: {
      dialog(val) {
        val || this.closeDialog();
      }
    },
    methods: {
        open() {
          this.dialog = true;
        },
        closeDialog() {
          this.dialog = false;
        },
        leave(){
          this.$emit('leave', this.nextFunction);
        },
        stay(){
          this.$emit('stay');
          this.closeDialog();
        }
    },
    components: {
      Button
    }
}
</script>
